<template>
  <Loading v-if="isLoading" />
  <BouyguesError v-if="!isLoading && error" @try-again="refresh" />

  <BouyguesAccount
    v-if="!isLoading && bouyguesAccount"
    :is-account-existing="bouyguesAccount.existing"
  />
</template>

<script setup lang="ts">
import { computed, onMounted, onUnmounted, ref } from 'vue'

import BouyguesError from '../../components/BouyguesError/BouyguesError.vue'
import { useUser } from '../../composables/useUser'

import BouyguesAccount from './components/BouyguesAccount/BouyguesAccount.vue'
import Loading from './components/Loading/Loading.vue'
import { useBouyguesAccount } from './composables/useBouyguesAccount'

const user = useUser()

const { bouyguesAccount, pending, error, refresh } = await useBouyguesAccount(
  user.email,
)

const isMinTimeElapsed = ref(false)
const setTimeoutId = ref()

const isLoading = computed(() => {
  return !isMinTimeElapsed.value || pending.value
})

onMounted(() => {
  setTimeoutId.value = setTimeout(() => {
    isMinTimeElapsed.value = true
  }, 3000)
})

onUnmounted(() => {
  clearTimeout(setTimeoutId.value)
})
</script>
